import classNames from "classnames";
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import { push } from "react-router-redux";
import _ from "underscore";

import { apiPromiseHook } from "../../shared/flux/actions/enterHooks";
import { RoutesInvoker } from "../routesInvoker";
import { EnterHookPromises } from "../state/enterHookPromises";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./destinations.scss";

interface StateProps {
  regions?: IRegionSummary[];
  countries?: IState<ICountrySummary[]>;
}

interface DispatchProps {
  navigateToPath: (path: string) => void;
}

type Props = DispatchProps & StateProps;

class DestinationsComponent extends React.Component<Props> {

  private renderCountries = (): JSX.Element[] => {
    if (!this.props.regions && !this.props.countries) {
      return null;
    }
    const cs = _.groupBy(this.props.countries.data, c => c.parent.id);
    const countries: JSX.Element[] = _.map(cs, (cg, key) => (
      <div key={key} className="destinations__section">
        <h3 className="destinations__region">{_.find(this.props.regions, r => r.id === parseInt(key, 10)).name}</h3>
        <div className="columns is-multiline is-mobile">
          {cg.map(cgg => (
            <div className="destinations__country-column is-6-mobile is-3-tablet column" key={cgg.id}>
              <Link className="destinations__country"
                to={WebRoutes.country(cgg.slug, cgg.parent.slug)}
              >
                {cgg.name}
              </Link>
            </div>
          ))}
        </div>
      </div>
    ));
    return countries;
  }

  public render() {
    return (
      <div className="destinations">
        <Helmet
          title="Holiday destinations tailor-made for you"
          meta={[
            {
              name: "description",
              content: "The best holiday destinations, personalised for you. Share your ideas with our local experts for a tailor-made holiday in your dream destination.",
            },
          ]}
          link={[
            {
              rel: "canonical",
              href: `${globalConfig.wwwBaseUrl}${WebRoutes.destinations()}`,
            },
          ]}
        />
        <div className="destinations__map-wrapper">
          <div className="width-wrapper">
            <div className="world-map-box p-top-medium p-bottom-medium">
              <h1>Our Destinations</h1>
              <h3 className="m-bottom-none">
                Select one of our destinations to inspire your next trip
              </h3>

              <div className="m-top-large world-map-container rs-xsmall-hide">
                {this.props.regions.map(r => <Link key={r.id} to={WebRoutes.region(r.slug)}><div className={classNames("label", r.slug)}>{r.name}</div></Link>)}
                <img className="world-map" src="images/world-map.svg" />
              </div>
            </div>
          </div>
        </div>

        <div className="destinations__list">
          <div className="width-wrapper">
            {this.renderCountries()}
          </div>
        </div>
        <div className="destinations__banner">
          {/* tslint:disable-next-line: max-line-length*/}
          Can't find where you want to go? <Link className="destinations__contact-button" to={WebRoutes.contactUs()}>Contact us</Link> and let us know where you want to go next.
        </div>
      </div>
    );
  }
}

const stateToProps = (state: IWebStoreState): StateProps => ({
  regions: _.sortBy(state.regions.data, r => r.id),
  countries: state.countries,
});

const dispatchToProps = (dispatch): DispatchProps => ({
  navigateToPath: (path: string) => dispatch(push(path)),
});

export const Destinations = connect(stateToProps, dispatchToProps)(DestinationsComponent);

export const destinationsOnEnter = apiPromiseHook(EnterHookPromises.allRegions(), EnterHookPromises.allCountries());
